import React from 'react';
import Modal from 'components/ModalFilter';
import moment from 'moment';
import { routes } from 'config/routes';

import third from 'assets/img/icons/third.svg';
import owner from 'assets/img/icons/owner.svg';
import tenant from 'assets/img/icons/tenant.svg';
import {
  Card, CloseButton, Container, Row, Title, EditTag, RowLabels, LabelText,
} from './styles';

import {
  BadgeLabel, ServiceTitleCard, DateOfTask, RespPerson,
} from '../styles';

function TaskLabel({
  task, isOpen, setIsOpen, _push, isAdmin,
}) {
  const getBadgeRespPerson = () => {
    switch (task.responsibility_bucket_id) {
      case 2:
        return (
          <RespPerson size="13px">
            <img src={owner} alt="Proprietário" />
            <p>
              Proprietário
            </p>
          </RespPerson>
        );
      case 3:
        return (
          <RespPerson size="20px">
            <img src={tenant} alt="Inquilino" />
            <p>
              Inquilino
            </p>
          </RespPerson>
        );
      case 4:
        return (
          <RespPerson size="13px">
            <img src={third} alt="Terceiro" />
            <p>
              Terceiro
            </p>
          </RespPerson>
        );
      default:
        return (
          <RespPerson>
            <img src={owner} alt="Proprietário" />
            <p>
              Proprietário
            </p>
          </RespPerson>
        );
    }
  };


  const getDateOfTask = () => {
    let taskStatus = '';
    let dateValue = '';
    switch (task.status) {
      case 'hired':
        taskStatus = 'Contratado em';
        dateValue = task.selected_date;
        break;
      case 'charged':
        taskStatus = 'Serviço realizado em';
        dateValue = task.schedule_date;
        break;
      case 'canceled':
        taskStatus = 'Cancelado em';
        dateValue = task.updated_at;
        break;
      case 'paid':
        taskStatus = 'Pago em';
        dateValue = task.paid_date;
        break;
      case 'open':
        taskStatus = 'Pedido em';
        dateValue = task.created;
        break;
      default:
        return '';
    }

    return (
      task.status !== 'canceled' && (
        <DateOfTask>
          {taskStatus}
          &nbsp;
          {dateValue && moment(dateValue).format('DD/MM/YYYY')}
        </DateOfTask>
      )
    );
  };

  const goToDetails = () => {
    _push(`${routes.taskDetails.replace(':taskId', task.id)}/detalhes`);
  };
  return (
    <Modal
      width="422px"
      height="570px"
      padding="40px"
      isOpen={isOpen}
      textTransform="none"
      title="Mais filtros"
      textalingheader="left"
      toggle={() => setIsOpen(!isOpen)}
    >
      <Container>
        <Title>Pedido</Title>
        <Card isAdmin={isAdmin}>
          {getBadgeRespPerson()}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ServiceTitleCard>{task.service_name}</ServiceTitleCard>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${process.env.BO_PATH}/task/${task.id}`}
            >
              #
              {task.id}
            </a>
          </div>
          {getDateOfTask()}
        </Card>
        <Row>
          <Title>Tags Selecionadas</Title>
          <EditTag type="button" onClick={goToDetails}>Editar tags</EditTag>
        </Row>
        <RowLabels>
          {task.labels.map(label => (
            <BadgeLabel key={label.id} color={label.color}>
              <LabelText color={label.color}>
                {label.name}
              </LabelText>
            </BadgeLabel>
          ))
        }
        </RowLabels>
        <CloseButton type="button" onClick={() => setIsOpen(false)}>
          Fechar
        </CloseButton>
      </Container>
    </Modal>
  );
}

export default TaskLabel;
